import classNames from 'classnames';
import StyledText from 'epic-fortnite-react/components/common/StyledText';
import PropTypes from 'prop-types';
import React from 'react';

import ImageCta from '../battlePass/ImageCta';

import BackgroundImageClip from './BackgroundImageClip';
import StyledBackgroundImageVideo from './StyledBackgroundImageVideo';
import StyledImage from './StyledImage';
import {getBackgroundStyle} from './utils';
import Video from './Video';

/**
 * Presents a logo, title, video with a background image.
 */
class BackgroundImageVideo extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
  };

  render() {
    const {data, tablet, mobile} = this.props;
    const backgroundStyle = getBackgroundStyle(data, tablet, mobile);
    const {text, logo, video, videoClickToPlay, videoType} = data;
    const wrapperClasses = classNames('wrapper', {
      nobackground: !backgroundStyle.backgroundImage,
    });
    const dataImageCta = {
      desktopImg: videoClickToPlay.desktopImg,
      mobileImg: videoClickToPlay.mobileImg,
      videoId: videoClickToPlay.videoId,
    };
    return (
      <StyledBackgroundImageVideo>
        <div className={wrapperClasses} style={backgroundStyle}>
          <div className="logo">
            <StyledImage data={logo} />
            <StyledText data={text} />
          </div>
          {videoType === 'clickToPlay' && videoClickToPlay && videoClickToPlay.videoId && (
            <ImageCta mobile={mobile} data={dataImageCta} />
          )}
          {videoType === 'autoPlay' && video && video.enabled && (
            <Video data={video} tablet={tablet} mobile={mobile} />
          )}
          <BackgroundImageClip />
        </div>
      </StyledBackgroundImageVideo>
    );
  }
}

export default BackgroundImageVideo;
